import { render, staticRenderFns } from "./CtaHamacaBabybjorn.vue?vue&type=template&id=f314e10c"
import script from "./CtaHamacaBabybjorn.vue?vue&type=script&lang=js"
export * from "./CtaHamacaBabybjorn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports